import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/edge-gateways/$id/variables")({
  staticData: {
    title: "edge.navigation.variables",
  },
});
